import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { clientAccountsPageValidateSearchSchema } from '../../products/ClientAccountsPage/route';
import { accountTerminationReason } from '../constants/accountTerminationReason';
import { accountTerminationRoute } from '../route';

export const accountTerminationProductsRoute = createRoute({
	getParentRoute: () => accountTerminationRoute,
	path: '/1-products',
	component: lazyRouteComponent(
		() => import('./AccountTerminationProductsPage'),
		'AccountTerminationProductsPage',
	),
	validateSearch: clientAccountsPageValidateSearchSchema.extend({
		reason: z.enum(accountTerminationReason),
		reasonNote: z.string().optional(),
	}),
});
